export default "__VITE_ASSET__BmrJBu0Q__"